export default __webpack_public_path__ + "static/media/bento_logo.fcc8b0ef.webp";